import { css } from '@emotion/css';

import { cn } from '@lyearn/style';
import { Accordion } from '@lyearn/ui';

import { BaseAccordionProps } from '../types';

const accordionStyles = css`
  &.MuiAccordion-root {
    border: none;
    box-shadow: none;

    &:before {
      display: none;
    }

    &.Mui-expanded {
      margin: auto;
    }
  }
`;

function AccordionComponent(props: BaseAccordionProps) {
  const { children, section, sectionIndex, className, ...rest } = props;

  return (
    <Accordion className={cn(accordionStyles, className)} {...rest}>
      {children}
    </Accordion>
  );
}

export default AccordionComponent;
